import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ClientRoute = () => {
  const { isClient, isLoading } = useAuth();

  // If still loading, show loading spinner
  if (isLoading) {
    return (
      <div className="container mt-4">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  // If user is not client, redirect to home
  if (!isClient()) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ClientRoute; 